/**
 * Footer - כותרת תחתונה
 * Holds the legally-required links that must be reachable from every page:
 * accessibility statement (הצהרת נגישות), privacy policy, terms of use, and
 * cookie policy.
 */

import { Link } from 'react-router-dom'

export default function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer className="mt-auto border-t border-gray-200 bg-white text-gray-600">
      <div className="max-w-6xl mx-auto px-4 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm">
        <p>© {year} יפתח ונגר — ייעוץ השקעות ופנסיה. כל הזכויות שמורות.</p>
        <nav aria-label="קישורים בתחתית העמוד">
          <ul className="flex flex-wrap items-center gap-4">
            <li>
              <Link to="/accessibility" className="text-primary-700 underline hover:text-primary-800">
                הצהרת נגישות
              </Link>
            </li>
            <li>
              <Link to="/privacy" className="text-primary-700 underline hover:text-primary-800">
                מדיניות פרטיות
              </Link>
            </li>
            <li>
              <Link to="/terms" className="text-primary-700 underline hover:text-primary-800">
                תקנון ותנאי שימוש
              </Link>
            </li>
            <li>
              <Link to="/cookies" className="text-primary-700 underline hover:text-primary-800">
                מדיניות עוגיות
              </Link>
            </li>
            <li>
              <Link to="/install" className="text-primary-700 underline hover:text-primary-800">
                התקנת האפליקציה
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </footer>
  )
}
